import React from 'react';
import OnboardingForm from './components/OnboardingForm';

const TestOnboarding: React.FC = () => {
  const handleComplete = () => {
    console.log('Onboarding completed!');
    alert('Onboarding completed! Check console for details.');
  };

  return (
    <div>
      <div style={{position: 'fixed', top: '10px', left: '10px', background: 'green', color: 'white', padding: '10px', zIndex: 9999}}>
        TEST MODE: Onboarding Form
      </div>
      <OnboardingForm onComplete={handleComplete} />
    </div>
  );
};

export default TestOnboarding;
